import useSelect from '../hooks/useSelect'

export type IfPostTypeProps = React.PropsWithChildren<
  | {
      equals: string
    }
  | {
      in: string[]
    }
>

export default function IfPostType(props: IfPostTypeProps) {
  const currentPostType = useSelect((select) =>
    select('core/editor').getCurrentPostType()
  )
  if ('equals' in props) {
    return currentPostType === props.equals ? props.children : null
  }
  if ('in' in props) {
    return props.in.includes(currentPostType) ? props.children : null
  }
}
